import React, { useEffect } from 'react';
import { Box, Card, CardContent, CircularProgress, Button } from '@mui/material';
import ButtonGroup from '@mui/material/ButtonGroup';
import { ResponsiveContainer } from 'recharts';
import LineChartReport from '../../Board/Report/LineChart';
import { useActivityDashboardStore } from '../../../utils/activityDashboardStore';

const ActivityLineChart = () => {
  const LineChartButtonGroup = [
    { label: 'Daily', value: 'daily' },
    { label: 'Weekly', value: 'weekly' },
    { label: 'Monthly', value: 'monthly' },
    { label: 'Yearly', value: 'yearly' },
  ];
  const {
    loading,
    activityReport,
    setChartType,
    chartType,
    fetchActivityReport,
    makeChartTypeDisable,
  } = useActivityDashboardStore();

  const data = { data: activityReport?.activitySummary || [], tile: 'tasks' };

  const handleButtonChange = (name) => {
    setChartType(name);
  };

  useEffect(() => {
    if (chartType) {
      fetchActivityReport();
    }
  }, [chartType]);

  return (
    <Card>
      <CardContent>
        {loading?.activityReport === true ? (
          <Box display="flex" justifyContent="center" alignItems="center" pt={4}>
            <CircularProgress size={26} style={{ marginBottom: 16 }} color="secondary" />
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <Box style={{ display: 'flex', justifyContent: 'space-between', height: '28px' }}>
              <Box sx={{ fontWeight: 600, mt: 1 }}>Trend Analysis</Box>
              <ButtonGroup
                size="small"
                aria-label="Small button group"
                variant="outlined"
                sx={{ height: '28px' }}
              >
                {LineChartButtonGroup?.map((item, index) => {
                  return (
                    <Button
                      key={index}
                      onClick={() => handleButtonChange(item?.value)}
                      disabled={makeChartTypeDisable?.includes(item?.value)}
                    >
                      <Box
                        sx={{ color: item?.value === chartType ? '#1976D2' : '#666', fontSize: 12 }}
                      >
                        {item?.label || ''}
                      </Box>
                    </Button>
                  );
                })}
              </ButtonGroup>
            </Box>
            <LineChartReport
              data={data}
              wrapperStyle={{ border: '1px solid #1864B0' }}
              sortOrder={[
                'Enrolled',
                'Open Rate',
                'All Tasks',
                'Call Backs',
                'LinkedIn',
                'Interested',
              ]}
            />
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default ActivityLineChart;
